<template>
<div class="QuestionList" v-if="init">
    <NoData v-if="!dataList.length"></NoData>
    <pull :pull="pull" :page="page" @getList="getList">
        <div class="favoriteList">
            <div class="box" v-for="(obj) in dataList" :key="obj.courseid" @click="handleCourseView(obj)">
                <div class="left"><img class="img" v-lazy="obj.coverurl" alt=""></div>
                <div class="right">
                    <div class="subject">{{obj.subject}}</div>
                    <div class="price">
                        <span class="tc-blue" v-if="obj.feetype == 1">免费</span>
                        <div v-else>
                            <span class="saleprice tc-red">{{obj.saleprice}}</span>
                            <span class="uprice tc-grey">{{obj.uprice}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </pull>
</div>
</template>

<script>
import {getMyCollectlist} from 'api/systemApi'
import Pull from 'views/mobile/components/pull/pull'
import {mapActions, mapGetters} from 'vuex'
import NoData from 'views/mobile/components/noData/noData'
export default {
    name: 'QuestionList',
    data() {
        return {
            init: false,
            dataList: [],
            param: {
                kmctype: 8
            },
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            }
        }
    },
    mounted() {
        this.getList()
        this.setNoDataTip('当前还没有收藏题库，快去学习收藏吧！')
        if (!this.refresh) {
            this.getList()
        }
    },
    activated() {
        if (this.refresh) {
            this.getList()
            this.setRefresh(false)
        }
    },
    methods: {
        handleCourseView(obj) {
            this.$router.push({name: 'PaperDetails', query: {qid: obj.innerid}})
            this.setRefresh(true)
        },
        getList() {
            this.setLoading(true)
            getMyCollectlist({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.init = true
                    if (this.page.page === 1) {
                        this.pull.isLoading = false
                        this.dataList = data.data.content
                    } else {
                        this.dataList = this.dataList.concat(data.data.content)
                    }
                    this.setLoading(false)
                    this.pull.loading = false
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.page.rowCount = data.data.pageinfo.rowCount
                    if (this.page.page === this.page.pageCount) {
                        this.pull.finished = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setRefresh', 'setNoDataTip'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['refresh'])
    },
    components: {
        Pull, NoData
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.QuestionList {
    .favoriteList{
        padding: 0.16rem 0.32rem;
        background: $c-white;
        .box{
            display: flex;
            justify-content: flex-start;
            font-size:0.28rem;
            font-weight: 600;
            padding: 0.16rem 0;
            margin-top: 0.2rem;
            background: $c-white;
            .left{
                min-width:2.6rem;
                max-width: 2.6rem;
                width: 2.6rem;
                height: 1.46rem;
                margin-right:0.2rem;
                .img{
                    width: 100%;
                    height: 100%;
                    border-radius: 0.04rem;
                }
            }
            .right{
                width: 4.84rem;
                .subject{
                    height: 0.8rem;
                    line-height: 0.4rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .price{
                    margin-top: 0.2rem;
                    font-size: 0.28rem;
                    .uprice{
                        margin-left: 0.2rem;
                        font-size: 0.24rem;
                        text-decoration:line-through
                    }
                }
            }
        }
    }
    .noData{
        height: 100vh;
        background: $c-white;
    }
}
</style>